{
	"content": {
		"title": "Vyberte materiály, které vyžadují prohlášení",
		"materialListLabel": "Materiál",
		"materialQuantityLabel": "Množství materiálu ({{unit}})",
		"availableQuantityLabel": "Dostupné množství ({{unit}})",
		"carbonSavingsLabel": "Snížení emisí uhlíku ({{unit}} CO₂ ekv.)"
	},
	"summary": {
		"title": "Shrnutí",
		"declarationTypeTitle": "Typ prohlášení",
		"customerProjectTitle": "Zákaznický projekt",
		"internalProjectOrProductTitle": "Interní projekt / produkt",
		"projectReferenceTitle": "Reference projektu",
		"materialHeaderTitle": "Materiál",
		"quantityHeaderTitle": "Množství ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Přidělitelné snížení uhlíku ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Nepřidělitelné snížení uhlíku ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "Je požadováno množství",
		"quantityPositive": "Zadejte kladné množství.",
		"quantityLargerThanAvailable": "Snižte množství na celkové dostupné množství",
		"savingsRequired": "Vyžaduje se redukce uhlíku",
		"fetchNotTransferedMaterialsError": "Nepodařilo se načíst nepřenesené materiály"
	},
	"submitTitle": "Přidat do projektu",
	"backTitle": "Zpět"
}
